import { Injectable } from '@angular/core';
import { ILogInResponse } from './command/logIn.command';
// import { Observable } from 'rxjs/Observable';
// import { StorageService } from '../storage/storage.service';
// import { SessionService } from '../session/session.service';
// import { NavigationService } from '../utilities/navigation.service';
// import { StorageKeyEnum } from '../storage/storageKeyEnum.enum';
// import { RouterEnum } from '../../enums/navigation/router.enum';
// import { PermissionsService } from '../utilities/permissions.service';
// import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MagiisUserTypeEnum } from './enum/magiisUserType.enum';
import { GenericPlace } from '../models/generic-place.model';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { SessionService } from '../session/session.service';
import { StorageService } from '../storage/storage.service';
import { StorageKeyEnum } from '../storage/storageKeyEnum.enum';
import { NavigationService } from '../utilities/navigation.service';
import { RouterEnum } from '../enum/navigation/router.enum';
import { JwtService } from '../utilities/jwt.service';


export enum RolesEnum {
  ROLE_CARRIER = 'ROLE_CARRIER',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_CONTRACTOR = 'ROLE_CONTRACTOR',
  ROLE_CONTRACTOR_EMPLOYEE = 'ROLE_CONTRACTOR_EMPLOYEE',
  ROLE_CONTRACTOR_OPERATOR = 'ROLE_CONTRACTOR_OPERATOR',
  ROLE_CONTRACTOR_ADMINISTRATIVE = 'ROLE_CONTRACTOR_ADMINISTRATIVE',
  ROLE_CONTRACTOR_MANAGER = 'ROLE_CONTRACTOR_MANAGER',
  ROLE_CONTRACTOR_SECRETARY = 'ROLE_CONTRACTOR_SECRETARY',
  ROLE_CARRIER_OPERATOR = 'ROLE_CARRIER_OPERATOR',
  ROLE_CARRIER_ADMINISTRATIVE = 'ROLE_CARRIER_ADMINISTRATIVE',
  ROLE_CARRIER_MANAGER = 'ROLE_CARRIER_MANAGER',
  ROLE_VEHICLEOWNER = 'ROLE_VEHICLEOWNER',
  ROLE_DRIVER = 'DRIVER',
  ROLE_PASSENGER = "PASSENGER",
  VEHICLEOWNER = 'VEHICLEOWNER',
  CONTRACTOR = 'CONTRACTOR',
}

@Injectable()
export class IdentityService {
  private _sessionToken: string;
  private _firebaseToken: string;
  private _country: string;
  private _userId: string;
  private _userType: MagiisUserTypeEnum;
  private _email: string;
  private _fullName: string;
  private _imageLogo = new BehaviorSubject<string>('');
  private _carrierCode: string;
  private _limitCurrentAccount = 2000; // REMOVE THIS
  private _rol: string;
  private _permissions = new Array<string>();
  private _someTime: boolean;
  private _agreedTerms: boolean;
  private _locationPlace: GenericPlace;
  private _passengerId: number;
  private _pageSize: number;
  private _fantasyName: string;
  private _subUserId: string;
  private _subUserPassengerId: number;
  private _defaultLanguage: string;
  private _countryCode: string;
  private _timezone: number;
  private _mercadoPagoAppId: number;
  private _mercadoPagoAppCode: string;
  private _mercadoPagoAvailable: boolean;
  private _mailchimpAppId: number;
  private _mailchimpAvailable: boolean;
  private _subUserName: string;
  private _affiliateProfileId: number;
  private _disableFunctions?: string[];
  private _affiliateProfileActive?: boolean;
  private _affiliateProfileCreditCardWarrantyExpired?: string;
  private _paymentVendorAvailableInCarrierCountry?: boolean;
  private _isOwnerPlatformUser?: boolean;
  private _flightApiAvailable?: boolean;
  private _flightApiName?: string;
  private _gnetApiAvailable?: boolean;
  private _maxRouteWaypoints?: number;
  private _carrier?: IUserInfoCarrier;

  constructor(
    private _storageService: StorageService,
    private _sessionService: SessionService,
    private _navigationService: NavigationService,
    // private _permissionsService: PermissionsService,
    private _jwtService: JwtService,
    // private _filterStorageService: FilterStorageService,
  ) {
    this._locationPlace = null;
  }

  get countryCode(): string {
    if (this._countryCode === undefined || this._countryCode === null) {
      this._countryCode = this._sessionService.getItem(
        StorageKeyEnum.countryCode
      );
    }
    return this._countryCode;
  }

  set countryCode(value: string) {
    this._countryCode = value;
    this._sessionService.setItem(StorageKeyEnum.countryCode, this._countryCode);
  }

  get defaultLanguage() {
    if (this._defaultLanguage === undefined || this._defaultLanguage === null) {
      this._defaultLanguage = this._sessionService.getItem(
        StorageKeyEnum.defaultLanguage
      );
    }
    return this._defaultLanguage;
  }

  set defaultLanguage(lang: string) {
    this._defaultLanguage = lang;
    this._sessionService.setItem(
      StorageKeyEnum.defaultLanguage,
      this._defaultLanguage
    );
  }

  get sessionToken() {
    if (!this._sessionToken) {
      this._sessionToken = this._sessionService.getItem(
        StorageKeyEnum.sessionToken
      );
      if (!this._sessionToken) {
        if (this.rol === RolesEnum.ROLE_ADMIN) {
          this._navigationService.navigate(RouterEnum.loginAdmin);
        } else {
          this._navigationService.navigate(RouterEnum.loginCarrier);
        }
      }
    }
    return this._sessionToken;
  }

  get hasTokenSession() {
    return this._sessionToken ? true : false;
  }

  get firebaseToken(): string {
    if (this._firebaseToken == null) {
      this._firebaseToken = this._sessionService.getItem(
        StorageKeyEnum.firebaseToken
      );
    }
    return this._firebaseToken;
  }

  set firebaseToken(value: string) {
    this._firebaseToken = value;
    this._sessionService.setItem(
      StorageKeyEnum.firebaseToken,
      this._firebaseToken
    );
  }

  get country(): string {
    if (this._country == null) {
      this._country = this._sessionService.getItem(StorageKeyEnum.userCountry);
    }
    return this._country;
  }

  get limitCurrentAccount(): number {
    // REMOVE THIS
    let limit = this._sessionService.getItem(
      StorageKeyEnum.limitCurrentAccount
    );
    if (limit === null || limit === undefined) {
      limit = this._storageService.getDataSync<string>(
        StorageKeyEnum.limitCurrentAccount
      );
    }
    if (limit === null || limit === undefined) {
      limit = 2000;
    }
    this._limitCurrentAccount = limit;
    return this._limitCurrentAccount;
  }

  get userId(): string {
    if (
      this._userId === undefined ||
      this._userId === null ||
      this._userId === ''
    ) {
      this._userId = this._sessionService.getItem(StorageKeyEnum.userId);
    }
    return this._userId;
  }

  get passengerId(): number {
    if (!this._passengerId) {
      this._passengerId = parseInt(
        this._sessionService.getItem(StorageKeyEnum.passengerId)
      );
    }
    return this._passengerId;
  }

  get userType(): string {
    if (this._userType === undefined || this._userType === null) {
      this._userType = this._sessionService.getItem(StorageKeyEnum.userType);
    }
    return this._userType;
  }

  get rol(): RolesEnum {
    if (this._rol === undefined || this._rol === null || this._rol === '') {
      this._rol = this.getSessionRole();
    }
    return RolesEnum[this._rol];
  }

  get permission(): Array<string> {
    if (!this._permissions || !this._permissions.length) {
      this._permissions = JSON.parse(
        this._sessionService.getItem(StorageKeyEnum.permissions)
      );
    }
    return this._permissions;
  }

  get access(): Array<string> {
    return this.getUserAccess();
  }

  get email(): string {
    if (this._email == null) {
      this._email = this._sessionService.getItem(StorageKeyEnum.userEmail);
    }
    return this._email;
  }

  get fullName(): string {
    if (this._fullName == null) {
      this._fullName = this._sessionService.getItem(StorageKeyEnum.fullName);
    }
    return this._fullName;
  }

  get fantasyName(): string {
    if (this._fantasyName == null) {
      this._fantasyName = this._sessionService.getItem(
        StorageKeyEnum.fantasyName
      );
    }
    return this._fantasyName;
  }

  set fantasyName(value: string) {
    this._fantasyName = value;
    this._sessionService.setItem(StorageKeyEnum.fantasyName, this._fantasyName);
  }

  get imageLogo(): BehaviorSubject<string> {
    this._imageLogo.next(
      this._sessionService.getItem(StorageKeyEnum.imageLogo)
    );
    return this._imageLogo;
  }

  get carrierCode() {
    if (this._carrierCode == null) {
      this._carrierCode = this._sessionService.getItem(
        StorageKeyEnum.carrierCode
      );
    }
    return this._carrierCode;
  }

  get someTime() {
    if (this._someTime == null) {
      this._someTime = this._sessionService.getItem(
        StorageKeyEnum.sometimeEntered
      );
    }
    return this._someTime;
  }
  get timezone() {
    if (this._timezone == null) {
      this._timezone = this._sessionService.getItem(StorageKeyEnum.timezone);
    }
    return this._timezone;
  }

  set someTime(value: boolean) {
    this._someTime = value;
    this._sessionService.setItem(
      StorageKeyEnum.sometimeEntered,
      this._someTime
    );
  }

  set timezone(value: number) {
    this._timezone = value;
    this._sessionService.setItem(StorageKeyEnum.timezone, this._timezone);
  }

  get pageSize(): number {
    this._pageSize = parseInt(
      this._sessionService.getItem(StorageKeyEnum.pageSize)
    );
    if (!this._pageSize) {
      this._pageSize = 20;
    }
    return this._pageSize;
  }

  set pageSize(value: number) {
    this._pageSize = value;
    this._sessionService.setItem(StorageKeyEnum.pageSize, this._pageSize);
  }

  get agreedTerms() {
    if (this._agreedTerms == null) {
      this._agreedTerms = JSON.parse(
        this._sessionService.getItem(StorageKeyEnum.agreedTerms)
      );
    }
    return this._agreedTerms;
  }

  set agreedTerms(value: boolean) {
    this._agreedTerms = value;
    this._sessionService.setItem(StorageKeyEnum.agreedTerms, this._agreedTerms);
  }

  get locationPlace(): GenericPlace {
    if (this._locationPlace == null) {
      this._locationPlace = this.loadLocationPlace();
    }
    return this._locationPlace;
  }

  get locationPlaceIsPresent(): boolean {
    return this._locationPlace != null;
  }

  get subUserId(): string {
    if (!this._subUserId) {
      this._subUserId = this._sessionService.getItem(StorageKeyEnum.subUserId);
    }
    return this._subUserId;
  }

  get subUserName(): string {
    if (!this._subUserName) {
      this._subUserName = this._sessionService.getItem(
        StorageKeyEnum.subUserName
      );
    }
    return this._subUserName;
  }

  get subUserPassengerId(): number {
    if (!this._subUserPassengerId) {
      this._subUserPassengerId = parseInt(
        this._sessionService.getItem(StorageKeyEnum.subUserPassengerId)
      );
    }
    return this._subUserPassengerId;
  }

  get mercadoPagoAppId(): number {
    if (!this._mercadoPagoAppId) {
      this._mercadoPagoAppId = parseInt(
        this._sessionService.getItem(StorageKeyEnum.mercadoPagoAppId)
      );
    }
    return this._mercadoPagoAppId;
  }

  get mercadoPagoAppCode(): string {
    if (!this._mercadoPagoAppCode) {
      this._mercadoPagoAppCode = this._sessionService.getItem(StorageKeyEnum.mercadoPagoAppCode);
    }
    return this._mercadoPagoAppCode;
  }

  get mercadoPagoAvailable(): boolean {
    if (!this._mercadoPagoAvailable) {
      this._mercadoPagoAvailable =
        this._sessionService.getItem(StorageKeyEnum.mercadoPagoAvailable) ===
        'true';
    }
    return this._mercadoPagoAvailable;
  }

  get mailchimpAppId(): number {
    if (!this._mailchimpAppId) {
      this._mailchimpAppId = parseInt(
        this._sessionService.getItem(StorageKeyEnum.mailchimpAppId)
      );
    }
    return this._mailchimpAppId;
  }

  get mailchimpAvailable(): boolean {
    if (!this._mailchimpAvailable) {
      this._mailchimpAvailable =
        this._sessionService.getItem(StorageKeyEnum.mailchimpAvailable) ===
        'true';
    }
    return this._mailchimpAvailable;
  }

  get affiliateProfileId(): number {
    if (!this._affiliateProfileId) {
      this._affiliateProfileId = this._sessionService.getItem(
        StorageKeyEnum.affiliateProfileId
      );
    }
    return this._affiliateProfileId;
  }

  get disableFunctions(): string[] {
    if (!this._disableFunctions) {
      return this.rol.includes(RolesEnum.ROLE_CARRIER) ? this._sessionService.getItem(StorageKeyEnum.disableFunctions) : [];
    }
    return this._disableFunctions;
  }

  get affiliateProfileActive(): boolean {
    if (!this._affiliateProfileActive) {
      this._affiliateProfileActive = this._sessionService.getItem(
        StorageKeyEnum.affiliateProfileActive
      );
    }
    return this._affiliateProfileActive;
  }

  get affiliateProfileCreditCardWarrantyExpired(): string {
    if (!this._affiliateProfileCreditCardWarrantyExpired) {
      this._affiliateProfileCreditCardWarrantyExpired =
        this._sessionService.getItem(
          StorageKeyEnum.affiliateProfileCreditCardWarrantyExpired
        );
    }
    return this._affiliateProfileCreditCardWarrantyExpired;
  }

  get paymentVendorAvailableInCarrierCountry(): boolean {
    if (!this._paymentVendorAvailableInCarrierCountry) {
      this._paymentVendorAvailableInCarrierCountry =
        this._sessionService.getItem(
          StorageKeyEnum.paymentVendorAvailableInCarrierCountry
        );
    }
    return this._paymentVendorAvailableInCarrierCountry;
  }

  get isOwnerPlatformUser(): boolean {
    if (!this._isOwnerPlatformUser) {
      this._isOwnerPlatformUser = this._sessionService.getItem(
        StorageKeyEnum.isOwnerPlatformUser
      );
    }

    return this._isOwnerPlatformUser;
  }

  get flightApiAvailable(): boolean {
    if (!this._flightApiAvailable) {
      this._flightApiAvailable = this._sessionService.getItem(
        StorageKeyEnum.flightApiAvailable
      );
    }

    return this._flightApiAvailable;
  }

  get flightApiName(): string {
    if (!this._flightApiName) {
      this._flightApiName = this._sessionService.getItem(
        StorageKeyEnum.flightApiName
      );
    }

    return this._flightApiName;
  }

  get gnetApiAvailable(): boolean {
    if (!this._gnetApiAvailable) {
      this._gnetApiAvailable = this._sessionService.getItem(
        StorageKeyEnum.gnetApiAvailable
      );
    }
    return this._gnetApiAvailable;
  }

  set gnetApiAvailable(value: boolean) {
    this._gnetApiAvailable = value;
    this._sessionService.setItem(StorageKeyEnum.gnetApiAvailable, this._gnetApiAvailable);
  }

  get maxRouteWaypoints(): number {
    if (!this._maxRouteWaypoints) {
      this._maxRouteWaypoints = this._sessionService.getItem(
        StorageKeyEnum.maxRouteWaypoints
      );
    }
    return this._maxRouteWaypoints;
  }

  set maxRouteWaypoints(value: number) {
    this._maxRouteWaypoints = value;
    this._sessionService.setItem(StorageKeyEnum.maxRouteWaypoints, this._maxRouteWaypoints);
  }

  get carrier(): IUserInfoCarrier {
    if (!this._carrier) {
      const aux = this._sessionService.getItem(
        StorageKeyEnum.userInfoCarrier
      );
      if(aux){
        try {
          this._carrier = JSON.parse(aux);
        } catch (error) {
        }
      }
    }
    return this._carrier;
  }

  public setUserInfo(userInfo: IUserInfo): Observable<boolean> {
    this._imageLogo.next(userInfo.userImage);
    this._country = userInfo.country;
    this._fullName = userInfo.fullName;
    this._email = userInfo.email;
    this._rol = userInfo.rol;
    this._carrierCode = userInfo.code;
    this._firebaseToken = userInfo.firebaseToken;
    this._userId = userInfo.id.toString();
    this._locationPlace = userInfo.locationPlace;
    this._passengerId = userInfo.passengerId;
    this._fantasyName = userInfo.fantasyName;
    this._subUserId = userInfo.subUserId;
    this._subUserPassengerId = userInfo.subUserPassengerId;
    this.countryCode = userInfo.countryCode;
    this.timezone = userInfo.timezone;
    this._mercadoPagoAppId = userInfo.mercadopagoAppId;
    this._mercadoPagoAppCode = userInfo.mercadopagoAppCode;
    this._mercadoPagoAvailable = userInfo.mercadoPagoAvailable;
    this._mailchimpAppId = userInfo.mailchimpAppId;
    this._mailchimpAvailable = userInfo.mailchimpAvailable;
    this._subUserName = userInfo.subUserName;
    this._affiliateProfileId = userInfo.affiliateProfileId;
    this._disableFunctions = userInfo.disableFunctions;
    this._affiliateProfileActive = userInfo.affiliateProfileActive;
    this._affiliateProfileCreditCardWarrantyExpired =
      userInfo.affiliateProfileCreditCardWarrantyExpired;
    this._paymentVendorAvailableInCarrierCountry =
      userInfo.paymentVendorAvailableInCarrierCountry;
    this._isOwnerPlatformUser = userInfo.isOwnerPlatformUser;
    this._flightApiAvailable = userInfo.flightApiAvailable;
    this._flightApiName = userInfo.flightApiName;
    this._gnetApiAvailable = userInfo.gnetApiAvailable;
    this._maxRouteWaypoints = userInfo.maxRouteWaypoints;
    this._carrier = userInfo.carrier;


    if (userInfo.locationPlace != null) {
      this.setLocationPlace(userInfo.locationPlace);
    }
    this._sessionService.setItem(StorageKeyEnum.disableFunctions, this._disableFunctions);

    this._sessionService.setItem(StorageKeyEnum.userId, this._userId);
    this._sessionService.setItem(StorageKeyEnum.userType, this._userType);
    this._sessionService.setItem(
      StorageKeyEnum.firebaseToken,
      this._firebaseToken
    );
    this._sessionService.setItem(StorageKeyEnum.fullName, this._fullName);

    this._sessionService.setItem(StorageKeyEnum.imageLogo, userInfo.userImage);
    this._sessionService.setItem(StorageKeyEnum.userCountry, this._country);
    this._sessionService.setItem(StorageKeyEnum.userEmail, this._email);
    this._sessionService.setItem(StorageKeyEnum.userRol, this._rol);
    this._sessionService.setItem(StorageKeyEnum.carrierCode, this._carrierCode);
    this._sessionService.setItem(StorageKeyEnum.passengerId, this._passengerId);
    this._sessionService.setItem(StorageKeyEnum.fantasyName, this._fantasyName);
    this._sessionService.setItem(StorageKeyEnum.subUserId, this._subUserId);
    this._sessionService.setItem(StorageKeyEnum.subUserPassengerId, this._subUserPassengerId);
    this._sessionService.setItem(StorageKeyEnum.mercadoPagoAppId, this._mercadoPagoAppId);
    this._sessionService.setItem(StorageKeyEnum.mercadoPagoAppCode, this._mercadoPagoAppCode);
    this._sessionService.setItem(StorageKeyEnum.mercadoPagoAvailable, this._mercadoPagoAvailable);
    this._sessionService.setItem(StorageKeyEnum.mailchimpAppId, this._mailchimpAppId);
    this._sessionService.setItem(StorageKeyEnum.mailchimpAvailable, this._mailchimpAvailable);
    this._sessionService.setItem(StorageKeyEnum.subUserName, this._subUserName);
    this._sessionService.setItem(
      StorageKeyEnum.affiliateProfileId,
      this._affiliateProfileId
    );
    this._sessionService.setItem(
      StorageKeyEnum.affiliateProfileActive,
      this._affiliateProfileActive
    );
    this._sessionService.setItem(
      StorageKeyEnum.affiliateProfileCreditCardWarrantyExpired,
      this._affiliateProfileCreditCardWarrantyExpired
    );
    this._sessionService.setItem(
      StorageKeyEnum.paymentVendorAvailableInCarrierCountry,
      this._paymentVendorAvailableInCarrierCountry
    );
    this._sessionService.setItem(StorageKeyEnum.isOwnerPlatformUser, this._isOwnerPlatformUser);

    this._sessionService.setItem(StorageKeyEnum.flightApiAvailable, this._flightApiAvailable);
    this._sessionService.setItem(StorageKeyEnum.flightApiName, this._flightApiName);
    this._sessionService.setItem(StorageKeyEnum.gnetApiAvailable, this._gnetApiAvailable);

    this._sessionService.setItem(StorageKeyEnum.maxRouteWaypoints, this._maxRouteWaypoints);
    if(this._carrier){
      this._sessionService.setItem(StorageKeyEnum.userInfoCarrier, JSON.stringify(this._carrier));
    } else {
      this._sessionService.setItem(StorageKeyEnum.userInfoCarrier, null);
    }

    try {
      const permissions: string = this.getSessionRole();
      // this._permissionsService.addRole(permissions);
      this._sessionService.setItem(StorageKeyEnum.userRol, permissions);
    } catch (error) {
      throw error;
    }

    return Observable.create(function (observer) {
      observer.next(true);
    });
  }

  public setLocationPlace(place: GenericPlace): void {
    this._sessionService.setItem(
      StorageKeyEnum.placeLAT,
      place.latitude.toString()
    );
    this._sessionService.setItem(
      StorageKeyEnum.placeLNG,
      place.longitude.toString()
    );
    this._sessionService.setItem(StorageKeyEnum.place, place.placeId);
    this._sessionService.setItem(StorageKeyEnum.placeName, place.shortName);
  }

  public loadLocationPlace(): GenericPlace {
    const place = new GenericPlace();
    place.latitude = parseInt(
      this._sessionService.getItem(StorageKeyEnum.placeLAT)
    );
    place.longitude = parseInt(
      this._sessionService.getItem(StorageKeyEnum.placeLNG)
    );
    place.placeId = this._sessionService.getItem(StorageKeyEnum.place);
    place.shortName = this._sessionService.getItem(StorageKeyEnum.placeName);

    return place;
  }

  async getLatLngCurrentPosition() {
    const place = new GenericPlace();
    try {
      const position = await this.getCurrentPosition();
      place.latitude = position.coords.latitude;
      place.longitude = position.coords.longitude;
      return place;
    } catch (error) {
      return place;
      console.error('Error retrieving location:', error);
      // Maneja el error, por ejemplo, mostrando un mensaje al usuario
    }
  }

  private getCurrentPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      });
    });
  }

  public setUserLogo(logo: string): void {
    this._imageLogo.next(logo);
    this._sessionService.setItem(StorageKeyEnum.imageLogo, logo);
  }

  public setLoginInfo(loginResponse: any): Observable<boolean> {
    //debugger;
    this._sessionToken = loginResponse.token;
    this._userId = loginResponse.userId;
    this._userType = loginResponse.userType;
    this._someTime = loginResponse.sometimeEntered;
    this._permissions = loginResponse.userPrivileges;
    this._sessionService.setItem(
      StorageKeyEnum.sessionToken,
      this._sessionToken
    );
    this._sessionService.setItem(
      StorageKeyEnum.sometimeEntered,
      this._someTime
    );
    this._sessionService.setItem(StorageKeyEnum.userId, this._userId);
    this._sessionService.setItem(
      StorageKeyEnum.permissions,
      JSON.stringify([this.getSessionRole()])
    );
    try {
      if (
        loginResponse.userPrivileges != null &&
        loginResponse.userPrivileges.length > 0
      ) {
        // this._permissionsService.addPermissions(loginResponse.userPrivileges);
      }
    } catch (error) {
      throw error;
    }

    return Observable.create(function (observer) {
      observer.next(true);
    });
  }

  public isLogged(): Observable<boolean> {
    return of(
      this._sessionService.getItem(StorageKeyEnum.sessionToken) !== null
    );
    /*return this._storageService
      .getData<string>(StorageKeyEnum.sessionToken)
      .flatMap(token => {
        if (token != null && token !== '') {
          this._sessionToken = token;
          return this._storageService
            .getData<string>(StorageKeyEnum.userId)
            .map(userId => {
              if (userId != null && userId !== '') {
                return Observable.create(function(observer) {
                  observer.next(true);
                });
              } else {
                return Observable.create(function(observer) {
                  observer.next(false);
                });
              }
            });
        } else {
          return Observable.create(function(observer) {
            observer.next(false);
          });
        }
      });*/
  }

  public logOut(): Observable<boolean> {
    this._country = '';
    this._userId = '';
    this._fullName = '';
    this._imageLogo = new BehaviorSubject<string>('');
    this._sessionToken = '';
    this._email = '';
    this._sessionService.clear();
    // this._permissionsService.cleanPermissions();
    this._storageService.deleteData(StorageKeyEnum.userId);
    this._fantasyName = '';
    this._rol = '';
    this._permissions = [];
    this._passengerId = null;
    this._pageSize = null;
    this._subUserId = null;
    this._subUserPassengerId = null;
    this._firebaseToken = '';
    this._limitCurrentAccount = null;
    this._locationPlace = null;
    this._userType = null;
    this._carrierCode = null;
    // this._filterStorageService.removeFilter('app-driver-list-dashboard', 'driver-status');
    // this._filterStorageService.removeFilter('app-driver-list-dashboard', 'map-driver-status');
    // this._filterStorageService.removeFilter('app-driver-list-dashboard', 'driver-name');
    return this._storageService.deleteData(StorageKeyEnum.sessionToken);
  }

  public loadPermissions() {
    let rol = this.rol;
    if (rol) {
      // this._permissionsService.addRole(this.rol);
    }
    let permission = this.permission;
    if (permission) {
      let permissionList = permission.toString().split(',');
      // this._permissionsService.addPermissions(permissionList);
    }
  }

  hasAnyRoleCarrier(): boolean {
    return this.rol.startsWith(RolesEnum.ROLE_CARRIER);
  }

  hasAnyRoleContractor(): boolean {
    return this.rol.startsWith(RolesEnum.ROLE_CONTRACTOR);
  }

  private getSessionRole(): string {
    const roles: string[] = this.getSessionRoles().split(',');
    if (localStorage.getItem('logged_role')) {
      return roles.find((r) => localStorage.getItem('logged_role') === r && r !== 'ROLE_CONTRACTOR_EMPLOYEE');
    } else {
      return roles.find((r) => r !== 'ROLE_CONTRACTOR_EMPLOYEE');
    }
  }

  private getSessionRoles(): string {
    return (
      this._jwtService.decode(
        this._sessionService.getItem(StorageKeyEnum.sessionToken)
      ) as any
    ).roles;
  }

  private getUserAccess(): string[] {
    return (
      this._jwtService.decode(
        this._sessionService.getItem(StorageKeyEnum.sessionToken)
      ) as any
    ).user_access;
  }

  public setToken(token: string) {
    this._sessionToken = token;
  }

  public setCountryCode(code: string) {
    this._countryCode = code;
  }

  public setCountry(country: string) {
    this._country = country;
  }

  public setMercadoPagoCode(code: string) {
    this._mercadoPagoAppCode = code;
  }

  public setMercadoPagoAppId(appId: number) {
    this._mercadoPagoAppId = appId;
  }

  public setMercadoPagoAvailable(available: boolean) {
    this._mercadoPagoAvailable = available;
  }

  public getIsNotificacionEnable():boolean{
    return this._sessionService.getItem(StorageKeyEnum.isNotificacionEnable)
  }

  public setIsNotificacionEnable(enabled: boolean){
    this._sessionService.setItem(StorageKeyEnum.isNotificacionEnable, enabled);
  }
}

export interface IUserInfo {
  countryCode?: string;
  id: number;
  userImage: string;
  country: string;
  fullName: string;
  email: string;
  rol: RolesEnum;
  code: string;
  firebaseToken?: string;
  locationPlace: GenericPlace;
  passengerId?: number;
  fantasyName: string;
  subUserId?: string;
  subUserPassengerId?: number;
  timezone?: number;
  mercadopagoAppId?: number;
  mercadopagoAppCode?: string;
  mercadoPagoAvailable?: boolean;
  mailchimpAppId?: number;
  mailchimpAvailable?: boolean;
  subUserName?: string;
  affiliateProfileId?: number;
  disableFunctions?: string[];
  affiliateProfileActive?: boolean;
  affiliateProfileCreditCardWarrantyExpired?: string;
  paymentVendorAvailableInCarrierCountry?: boolean;
  isOwnerPlatformUser?: boolean;
  isContractorPlatformUser?: boolean;
  flightApiAvailable?: boolean;
  flightApiName?: string;
  gnetApiAvailable?: boolean;
  maxRouteWaypoints?: number;
  carrier?: IUserInfoCarrier;
}

export interface IUserInfoCarrier {
  carrierId: number;
  companyName: string;
  contactEmail: string;
  phoneNumber: string;
}

